import React from 'react'

export const ClinicView = () => {
    return (
        <div className='bg-white rounded-lg h-full my-10 p-16 flex flex-col items-center w-full'>
            <div className='h-40 w-40 rounded-full border-2 border-blue-500'>

            </div>
            <h2 className='font-bold text-xl'>C4C Name</h2>
            <div className='w-full mt-5'>
                <div className='flex justify-between'>
                    <div className='flex flex-col gap-2'>
                        <h2 className='text-lg font-bold'>Location</h2>
                        <p className='text-gray-500'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt, quos.</p>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <h2 className='text-lg font-bold'>Phone</h2>
                        <p className='text-gray-500'>+234 123 456 7890</p>
                    </div>
                </div>
                <div className='flex justify-between mt-5'>
                    <div className='flex flex-col gap-2'>
                        <h2 className='text-lg font-bold'>Email</h2>
                        <p className='text-gray-500'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt, quos.
                        </p>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <h2 className='text-lg font-bold'>Website</h2>
                        <p className='text-gray-500'>www.c4c.com</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
